'use client';

import { getEnvironment } from '@base/environment';
import { ErrorBoundaryTemplate } from '@pods/templates/errors/components/error-boundary';
import type { ErrorBoundaryTemplateProps } from '@pods/templates/errors/types';

/**
 * Error Boundary
 *
 * Cosmic theme matching the marketing website design system.
 * Handles runtime errors with recovery options.
 */
export default function ErrorPage({
  error,
  reset
}: {
  error: Error & { digest?: string | undefined };
  reset: () => void;
}) {
  const actions: ErrorBoundaryTemplateProps['actions'] = [
    {
      label: 'Try Again',
      onClick: reset,
      variant: 'default'
    },
    {
      label: 'Go Home',
      href: '/',
      variant: 'outline'
    },
    {
      label: 'Contact Support',
      href: '/contact',
      variant: 'ghost'
    }
  ];

  return (
    <ErrorBoundaryTemplate
      error={error}
      reset={reset}
      theme="cosmic"
      appName="pulse-website"
      title="Something went wrong"
      message="An unexpected error occurred. Please try again or contact our support team."
      actions={actions}
      showErrorDetails={getEnvironment() !== 'production'}
      enableLogging={true}
    />
  );
}
